import Joi from 'joi';

import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { ReportTemplateTypeEnum } from '../../enums/report-template-type.enum';

/**
 * Schema for existing report template record validation.
 */
export const updateReportTemplateSchema = () =>
	Joi.object({
		type: Joi.alternatives()
			.conditional(Joi.any().valid(null), {
				then: Joi.invalid(null).messages({
					'any.invalid': 'validations|report-template-type|cannot-be-null',
				}),
				otherwise: Joi.string()
					.valid(...Object.values(ReportTemplateTypeEnum))
					.required()
					.messages({
						'any.required': 'validations|report-template-type|required',
						'any.only': 'validations|report-template-type|invalid-value',
					}),
			})
			.prefs({ abortEarly: true }),

		// User id
		userId: Joi.number().allow(null).optional(),

		// Tags
		tags: createTagsSchema().messages({
			'array.base': 'validations|report-template-tags|invalid-value',
		}),
	})
		// Ignore extra fields
		.unknown();
